'use strict';

/* CHANGE END DATE -- insert preferred date in same format*/
const endDate = new Date('Dec 28, 2022 23:59:59');
/* SWITCH TO SINGLE DIGIT DAYS --- if true single days won't have a leading 0*/
const singleDigitForSingleDays = false;

function setCountdownInterval() {
	const initialDate = Date.now();
	const initialMillis = endDate - initialDate;
	const initialMillisObject = convertMillis(initialMillis);

	if (initialDate > endDate) {
		return;
	}

	setCounterInDOM(initialMillisObject);

	window.setInterval(function() {
		const date = Date.now();
		const millis = endDate - date;
		const millisObject = convertMillis(millis);

		if (date > endDate) {
			clearInterval();
			return;
		}

		setCounterInDOM(millisObject);

	}, 1000);
}

function setCounterInDOM(dateObject) {
	const firstLetterOfDays = document.querySelector('.benefits__item-counter-days-letter--first span');
	const secondLetterOfDays = document.querySelector('.benefits__item-counter-days-letter--second span');
	const firstDaysIsPresent = firstLetterOfDays !== null;
	const daysArray = dateObject.d.toString().split('');
	const daysArrayLength = daysArray.length;

	if (daysArrayLength === 2) {
		firstLetterOfDays.parentElement.classList.remove('d-none');
		firstLetterOfDays.innerText = daysArray[0];
		secondLetterOfDays.innerText = daysArray[1];
		return;
	}

	if (singleDigitForSingleDays && firstDaysIsPresent) {
		firstLetterOfDays.parentElement.remove();
	}

	if (daysArray[0] === '1') {
		document.querySelector('.benefits__item-counter-text').innerText = 'A mai rămas';
		document.querySelector('.benefits__item-counter-label').innerText = 'zi';
	}

	firstLetterOfDays.parentElement.classList.remove('d-none');
	secondLetterOfDays.innerText = daysArray[0];
}

function convertMillis(milliseconds, format) {
	let days, total_hours, total_minutes, total_seconds;

	total_seconds = parseInt(Math.floor(milliseconds / 1000));
	total_minutes = parseInt(Math.floor(total_seconds / 60));
	total_hours = parseInt(Math.floor(total_minutes / 60));
	days = parseInt(Math.floor(total_hours / 24));

	switch (format) {
		case 'd':
			return days;
		default:
			return { d: days };
	}
};

module.exports.initCountdown = setCountdownInterval;